import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess,} from '../../actions/datasources/bulkFetch'
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'

function* process(data) {
  const { datasource_id } = data.payload; // Extract page and rowsPerPage from the action
  let response = null;
  try {
      response = yield call(
        axios.get,
        `${config.API_URL}/datasource/execute_bulk_fetch/${datasource_id}`,
        { headers: getLocalUser() }
      );
  
    yield put(fetchSuccess({...response.data.data, action: 'bulk_fetch'}));
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: `datasource ${datasource_id} bulk fetch executed successfully`});


  } catch (error) {

    yield put(fetchSuccess({...error.response.data.data}));
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message: `Could not bulk fetch datasource ${datasource_id}. ${error.toString()}`});
  }
}

export function* watch() {
  yield takeEvery(REQUEST, process);
}
